import videojs from 'video.js'

const Button = videojs.getComponent('Button')

class TurnOnSoundButton extends Button {
  constructor(player, options) {
    super(player, options)

    this.controlText('Turn On Sound')
  }

  buildCSSClass() {
    return 'vjs-turn-on-sound d-none d-md-block'
  }

  handleLanguagechange() {
  }

  handleClick() {
    this.player().muted(false)
    this.player().getChild('TurnOnSoundButton').hide()
    this.player().currentTime(0)
    this.player().play()
  }
}

export default function turnOnSoundButtonPlugin(_options) {
  videojs.registerComponent('TurnOnSoundButton', TurnOnSoundButton)

  this.ready(() => {
    const button = this.addChild('TurnOnSoundButton', {})

    this.on('playing', () => {
      if (!this.muted()) {
        button.hide()
      }
    })
    this.on('ended', () => {
      button.hide()
    })
    this.on('volumechange', () => {
      if (!this.muted()) {
        button.hide()
      }
      else {
        if (this.currentTime() === 0) {
          button.show()
        }
      }
    })
  })
}
